(() => {
  if (window.neEditorialInitialized) return;
  window.neEditorialInitialized = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupHero(root) {
    if (!root || root.dataset.neReady === 'true') return;
    root.dataset.neReady = 'true';
    const slides = [...root.querySelectorAll('[data-ne-slide]')];
    const dots = [...root.querySelectorAll('[data-ne-dot]')];
    const track = root.querySelector('[data-ne-hero-track]');
    const previous = root.querySelector('[data-ne-previous]');
    const next = root.querySelector('[data-ne-next]');
    if (!slides.length) return;
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    const transition = root.dataset.transition;
    const speed = Number(root.dataset.autoplaySpeed || 0) * 1000;

    const show = (nextIndex, announce = true) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      if (transition === 'slide' && track) track.style.transform = `translate3d(${-index * 100}%,0,0)`;
      if (announce) root.dispatchEvent(new CustomEvent('ne:slidechange', { detail: { index } }));
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (speed > 0 && slides.length > 1 && !reduceMotion) timer = window.setInterval(() => show(index + 1, false), speed);
    };
    previous?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(index, false);
    start();
  }

  function setupCarousel(root) {
    if (!root || root.dataset.neCarouselReady === 'true') return;
    root.dataset.neCarouselReady = 'true';
    const track = root.querySelector('[data-ne-track]');
    const previous = root.querySelector('[data-ne-previous]');
    const next = root.querySelector('[data-ne-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      const overflow = track.scrollWidth > track.clientWidth + 2;
      previous.disabled = !overflow || track.scrollLeft <= 2;
      next.disabled = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      previous.hidden = !overflow;
      next.hidden = !overflow;
    };
    const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .8, 260), behavior: reduceMotion ? 'auto' : 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    let updateFrame = 0;
    const scheduleUpdate = () => {
      if (updateFrame) return;
      updateFrame = requestAnimationFrame(() => { updateFrame = 0; update(); });
    };
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(track);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      resizeObserver.disconnect();
      cancelAnimationFrame(updateFrame);
    });
    update();
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ne-hero]').forEach(setupHero);
    scope.querySelectorAll('[data-ne-carousel]').forEach(setupCarousel);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
